import { render, staticRenderFns } from "./rma_details_dialog.vue?vue&type=template&id=65991b49&"
import script from "./rma_details_dialog.vue?vue&type=script&lang=js&"
export * from "./rma_details_dialog.vue?vue&type=script&lang=js&"
import style0 from "./rma_details_dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports